import { useEffect } from 'react';

function usePopstateHandler(handler: (event: PopStateEvent) => void) {
  useEffect(() => {
    window.addEventListener('popstate', handler);
    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, [handler]);
}
export default usePopstateHandler;
